import { routes } from '@/routes'

/**
 * Para onde voltar depois de entrar. Só o consentimento OAuth usa (docs/api/mcp.md, passo 6): o
 * cliente MCP abre `/oauth/consent?authorization_id=…` no navegador, e quem está sem sessão passa
 * pelo login (e, se for o caso, pela troca da senha ou pela escolha de clínica) antes de responder
 * ao pedido. O caminho fica no `sessionStorage`, que some ao fechar a aba, e só é aceito se for o
 * do consentimento: nenhum endereço de fora, nem outra rota do app, entra aqui.
 */
const KEY = 'wx-return-to'

function isConsentPath(path: string) {
  return path.startsWith(`${routes.oauthConsent}?`)
}

export function rememberReturnTo(path: string) {
  if (!isConsentPath(path)) return
  try {
    window.sessionStorage.setItem(KEY, path)
  } catch {
    // Sem armazenamento (modo restrito do navegador): a pessoa refaz a conexão pelo aplicativo.
  }
}

/** O caminho guardado, sem apagar: quem apaga é a tela de destino, quando a pessoa chega nela. */
export function peekReturnTo(): string | null {
  try {
    const path = window.sessionStorage.getItem(KEY)
    return path && isConsentPath(path) ? path : null
  } catch {
    return null
  }
}

export function forgetReturnTo() {
  try {
    window.sessionStorage.removeItem(KEY)
  } catch {
    // Nada a apagar.
  }
}
